import Link from 'next/link';
import { IoIosArrowForward } from 'react-icons/io';
import styles from '../../styles/components/common/Breadcrumb.module.css';

export default function Breadcrumb({ breadcrumbs = [] }) {
    if (!breadcrumbs || breadcrumbs.length === 0) {
        return null;
    }

    return (
        <div className={`tw-container ${styles.breadcrumbContainer}`}>
            <nav className={`${styles.breadcrumbNav}`} aria-label="Breadcrumb navigation">
                {breadcrumbs.map((crumb, index) => [
                    // Breadcrumb item (link or current page)
                    crumb.url && index < breadcrumbs.length - 1 ? (
                        <span key={`item-${index}`} className={styles.breadcrumbItem}>
                            <Link href={crumb.url} className={styles.breadcrumbLink}>
                                {crumb.name}
                            </Link>
                        </span>
                    ) : (
                        <span key={`item-${index}`} className={styles.breadcrumbCurrent} aria-current="page">
                            {crumb.name}
                        </span>
                    ),
                    // Separator (only if not the last item)
                    index < breadcrumbs.length - 1 && (
                        <span key={`separator-${index}`} className={styles.breadcrumbSeparator} aria-hidden="true">
                            {/* {' > '} */}
                            <IoIosArrowForward className={styles.breadcrumbSeparatorIcon} />
                        </span>
                    )
                ]).flat().filter(Boolean)}
            </nav>
        </div>
    );
}
